import { tForLocale, type Locale } from '../i18n/locale'

export function formatProbability(probability: number) {
  return `${Math.round(probability * 100)}%`
}

export function formatChange(change = 0) {
  const percentage = Math.round(change * 100)

  if (percentage === 0) {
    return '—'
  }

  return `${percentage > 0 ? '+' : ''}${percentage}%`
}

export function formatPercentagePoints(change: number) {
  const points = Math.abs(change * 100)
  return points < 1 ? '不到1' : String(Math.round(points))
}

export function formatVolume(value?: number, unit: 'usd' | 'contracts' | 'unknown' = 'unknown') {
  if (value === undefined) {
    return '—'
  }

  const prefix = unit === 'usd' ? '$' : ''
  const suffix = unit === 'contracts' ? ' 张' : unit === 'unknown' ? '（单位未知）' : ''

  if (value >= 1000000) {
    return `${prefix}${(value / 1000000).toFixed(1)}M${suffix}`
  }

  if (value >= 1000) {
    return `${prefix}${(value / 1000).toFixed(0)}K${suffix}`
  }

  return `${prefix}${value.toFixed(0)}${suffix}`
}

export function formatEndTime(endTime?: string, locale: Locale = 'zh-CN') {
  if (!endTime) {
    return tForLocale(locale, 'common.deadlineUnknown')
  }

  return new Intl.DateTimeFormat(locale === 'en' ? 'en-US' : 'zh-CN', {
    month: 'numeric',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
    timeZone: 'Asia/Shanghai',
  }).format(new Date(endTime))
}

export function formatUpdatedAt(updatedAt?: string | null, includeDate = false, locale: Locale = 'zh-CN') {
  if (!updatedAt || !Number.isFinite(Date.parse(updatedAt))) return tForLocale(locale, 'common.timeUnknown')

  return new Intl.DateTimeFormat(locale === 'en' ? 'en-US' : 'zh-CN', {
    ...(includeDate ? { month: 'short', day: 'numeric' } : {}),
    hour: '2-digit',
    minute: '2-digit',
    timeZone: 'Asia/Shanghai',
  }).format(new Date(updatedAt))
}
